import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import BaseWidget from '../BaseWidget';
import WebsiteNavigator from './WebsiteNavigator';
import WebsiteNavigatorMobileView from './WebsiteNavigatorMobileView';
import ClassNames from './WebsiteNavigator.less';
import MediaQuery from 'react-responsive';
import { HAMBURGER, HORIZONTAL } from './Constants';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
* Generic website navigator widget for displaying navigation on
* a website.
*/
export default class WebsiteNavigatorWidget extends BaseWidget {
  static displayName = 'WebsiteNavigatorWidget';
  static propTypes = {
    config: PropTypes.shape({
      shared: PropTypes.shape({
        pageLinksArrangement: PropTypes.oneOf([HORIZONTAL, HAMBURGER])
      })
    }),
    classes: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func,
    // Non-configurable props that should be added by the application specific wrapper.
    selectedPage: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    }),
    pageData: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      // childPages is an array of objects of the same type as pageData,
      // so the nesting of childPages can go down forever...I cant figure
      // out how to define that as a propType so just saying array of objects here
      childPages: PropTypes.arrayOf(PropTypes.object)
    })),
    navigateToPage: PropTypes.func,
    openNavigatorDialog: PropTypes.func,
    closeNavigatorDialog: PropTypes.func,
    leftContent: PropTypes.node,
    rightContent: PropTypes.node
  };
  static defaultProps = {
    classes: ClassNames
  };
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  }
  getStyleObject() {
    const containerStyles = super.getStyleObject();
    const backgroundColor = containerStyles.container.backgroundColor
      && containerStyles.container.backgroundColor !== 'transparent'
      ? containerStyles.container.backgroundColor
      : this.getParentBackground().backgroundColor;
    const pageLinks = this.getElementInlineStyle('pageLinks');
    return {
      ...containerStyles,
      navigation: {
        textAlign: this.getElementText('pageLinks').textAlign
      },
      pageLinks,
      header: {
        ...pageLinks,
        textAlign: 'left'
      },
      verticalMenu: { backgroundColor },
      subMenu: { backgroundColor }
    };
  }
  render() {
    const { classes, config, selectedPage, pageData, navigateToPage,
      openNavigatorDialog, closeNavigatorDialog, leftContent, rightContent, translate } = this.props;
    const { pageLinksArrangement } = config.shared;
    return (
      <MediaQuery query="only screen and (max-width: 30em)">
        {(matches) => {
          const Component = matches ? WebsiteNavigatorMobileView : WebsiteNavigator;
          return (
            <Component
              {...resolveTestId(this.props)}
              selectedPage={selectedPage}
              pageData={pageData}
              navigateToPage={navigateToPage}
              openNavigatorDialog={openNavigatorDialog}
              closeNavigatorDialog={closeNavigatorDialog}
              pageLinksArrangement={pageLinksArrangement}
              leftContent={leftContent}
              rightContent={rightContent}
              classes={classes}
              translate={matches ? translate : null}
              style={this.getStyleObject()} />
          );
        }}
      </MediaQuery>
    );
  }
}
